/** funciones para el formulario multipasos */
import axiosMailUpdate from '../services/axiosApi';
var functionsForm = {
	// funcion para saber las horas laborables que posee un cliente
	async hoursClient(idHour) {
		const response = await axiosMailUpdate.get(
			'api/v1/businesshours/' + idHour
		);
		this.response = response.data.data;
		return this.response.hora;
	},
	//funciones para las categorias, marcas y productos/servicios
	async infoCategories() {
		const response = await axiosMailUpdate.get(
			'api/v1/categories?sort_by=nombrecategoria'
		);
		this.response = response.data.data;
		return this.response;
	},
	async infoBrands() {
		const response = await axiosMailUpdate.get(
			'api/v1/brands?sort_by=nombre'
		);
		this.response = response.data.data;
		return this.response;
	},
	async productsServices() {
		const response = await axiosMailUpdate.get(
			'api/v1/productsservices?sort_by=nombre'
		);
		this.response = response.data.data;
		return this.response;
	},
	async getBrandsByCategorie(catId) {
		const response = await axiosMailUpdate.get(
			'api/v1/categories/' + catId + '/brands'
		);
		this.response = response.data.data;
		return this.response;
	},
	async getProductsServicesByCategorie(catId) {
		const response = await axiosMailUpdate.get(
			'api/v1/categories/' + catId + '/productsservices'
		);
		this.response = response.data.data;
		return this.response;
	},
	async getClientData(idRequest) {
		const response = await axiosMailUpdate.get(
			'/api/v1/requestsrows/' + idRequest + '/clientdataorigin'
		);
		this.response = response.data.data;
		let originalData = this.response.Original;
		let modifiedClient = this.response.ModifiedClient;
		let insideData = this.response.Inside;
		let objDataForForm = originalData;
		/** se recorre la propiedad ModifiedClient y se crea un objeto nuevo solo
		 * con las propiedades que tengan data
		 */
		if (modifiedClient != null) {
			objDataForForm = {};
			sessionStorage.setItem('idDataClients',modifiedClient.idDataClients);
			for (let keyOfModifiedClient of Object.keys(modifiedClient)) {
				if (typeof modifiedClient[keyOfModifiedClient] == 'string') {
					if (modifiedClient[keyOfModifiedClient] != null) {
						objDataForForm[keyOfModifiedClient] =
							modifiedClient[keyOfModifiedClient];
					}
				}
				if (typeof modifiedClient[keyOfModifiedClient] == 'number') {
					if (modifiedClient[keyOfModifiedClient] != 0) {
						objDataForForm[keyOfModifiedClient] =
							modifiedClient[keyOfModifiedClient];
					}
				}
				if (
					typeof modifiedClient[keyOfModifiedClient] == 'object' &&
					modifiedClient[keyOfModifiedClient] != null
				) {
					if (modifiedClient[keyOfModifiedClient].length > 0) {
						objDataForForm[keyOfModifiedClient] =
							modifiedClient[keyOfModifiedClient];
					}
				}
			}
			/** en el nuevo objeto se une la data de la propiedad Original de esa forma se crea un solo objeto
			 * con la data que se precargara al formulario
			 */
			objDataForForm = Object.assign({}, originalData, objDataForForm);
			if (insideData != undefined && insideData != null) {
				/** si la propiedad Inside existe se recorre para asignar al objeto objDataForForm
				 * las propiedades de Inside que tengan data
				 */
				sessionStorage.setItem('idDataClients',insideData.idDataClients);
				for (let keyOfInsideData of Object.keys(insideData)) {
					if (typeof insideData[keyOfInsideData] == 'string') {
						if (insideData[keyOfInsideData] != null) {
							objDataForForm[keyOfInsideData] =
								insideData[keyOfInsideData];
						}
					}
					if (typeof insideData[keyOfInsideData] == 'number') {
						if (insideData[keyOfInsideData] != 0) {
							objDataForForm[keyOfInsideData] =
								insideData[keyOfInsideData];
						}
					}
					if (
						typeof insideData[keyOfInsideData] == 'object' &&
						insideData[keyOfInsideData] != null
					) {
						if (insideData[keyOfInsideData].length > 0) {
							objDataForForm[keyOfInsideData] =
								insideData[keyOfInsideData];
						}
					}
				}
				objDataForForm = Object.assign(
					{},
					objDataForForm,
					objDataForForm
				);
			}
		}
		this.response.dataForForm = objDataForForm;
		return this.response;
	},
	// get para saber el nombre del estado del cliente
	async getStateForClient(idstate) {
		const response = await axiosMailUpdate.get('/api/v1/states/' + idstate);
		this.response = response.data.data;
		return this.response;
	},
	// get para las ciudades segun el estado del cliente
	async getCitiesFromClienteState(idstate) {
		const response = await axiosMailUpdate.get(
			'api/v1/states/' + idstate + '/cities?sort_by=nombreciudad'
		);
		this.response = response.data.data;
		return this.response;
	},
	// get para las urbanizaciones segun el estado del cliente
	async getUrbFromClientState(idstate) {
		const response = await axiosMailUpdate.get(
			'/api/v1/states/' + idstate + '/citiesurbanizations'
		);
		this.response = response.data.data;
		return this.response;
	},
	//get para obtener la urbanizacion seleccionada del cliente para el select del formulario
	async getSelectedUrbClient(idurbanization) {
		const response = await axiosMailUpdate.get(
			'/api/v1/urbanizations/' + idurbanization
		);
		this.response = response.data.data;
		return this.response;
	},
	//get para obtener la ciudad seleccionada del cliente para el select del formulario
	async getSelectedCityClient(idstate, idcity) {
		const response = await axiosMailUpdate.get(
			'/api/v1/states/' + idstate + '/cities/' + idcity
		);
		this.response = response.data.data;
		return this.response;
	},
	//get de los dias laborables
	async getBussinessDays() {
		const response = await axiosMailUpdate.get('/api/v1/businessdays');
		this.response = response.data.data;
		return this.response;
	},
	//get de las horas laborables
	async getBussinessHours() {
		const response = await axiosMailUpdate.get('/api/v1/businesshours');
		this.response = response.data.data;
		return this.response;
	},
	//get para el select de los numeros por departamento
	async getDedicatedNumbers() {
		const response = await axiosMailUpdate.get(
			'/api/v1/numbersdedicated?sort_by=nombre'
		);
		this.response = response.data.data;
		return this.response;
	},
	//get de las horas del cliente
	async getHoursClient(idHour) {
		const response = await axiosMailUpdate.get(
			'api/v1/businesshours/' + idHour
		);
		this.response = response.data.data;
		return this.response.hora;
	},
	//get para el select de las formas de pago
	async getPaymentMethods() {
		const response = await axiosMailUpdate.get(
			'api/v1/paymentsmethods?sort_by=nombre?sort_by=nombre'
		);
		this.response = response.data.data;
		return this.response;
	},
	//get de las categorias de infoguia
	async getInfoCategories() {
		const response = await axiosMailUpdate.get(
			'api/v1/categories?sort_by=nombrecategoria'
		);
		this.response = response.data.data;
		return this.response;
	},
	//get de las marcas de infoguia
	async getInfoBrands() {
		const response = await axiosMailUpdate.get(
			'api/v1/brands?sort_by=nombre'
		);
		this.response = response.data.data;
		return this.response;
	},
	//get de los productos/servicios de infoguia
	async getProductsServices() {
		const response = await axiosMailUpdate.get(
			'api/v1/productsservices?sort_by=nombre'
		);
		this.response = response.data.data;
		return this.response;
	},
	//lista todas las ciudades
	async allCities() {
		const response = await axiosMailUpdate.get(
			'api/v1/cities?sort_by=nombreciudad'
		);
		let objDataForForm = {};
		this.response = response.data.data;
		for (let keyOfResponse of Object.keys(this.response)) {
			if (this.response[keyOfResponse].codigotlf !== null) {
				this.response[keyOfResponse].codeForWhatsapp = this.response[
					keyOfResponse
				].codigotlf.substring(1);
				objDataForForm[keyOfResponse] = this.response[
					keyOfResponse
				].codigotlf.substring(1);
			}
		}
		objDataForForm = Object.assign({}, objDataForForm, objDataForForm);
		this.response.dataForForm = objDataForForm;
		// var uniq = {};
		// var arrFiltered = this.response.filter(
		// 	(obj) => !uniq[obj.codigotlf] && (uniq[obj.id] = true)
		// );
		return this.response;
	},
	//get de las horas del cliente
	getVerifyAreaCode(areaCode) {
		const response = axiosMailUpdate.get('/api/v1/cities/verifyareacode/' + areaCode
		);
		this.response = response;
		return this.response;
	},
};
export default functionsForm;
